import React from 'react';
import { splitBanner } from '@/components/ui/Banner/SplitBanner/styles';

export const SideText = ({ children }: React.PropsWithChildren) => {
  const { textContainer } = splitBanner();
  return (
    <div className={textContainer()}>
      <div className="2xl:max-w-[35rem]">{children}</div>
    </div>
  );
};
